import { Injectable, OnDestroy } from '@angular/core';
import { MC_EVENT_TYPE, MCFieldTypesService } from '@maslul/common-services';
import { MICustomFunctionsParams } from '../../models/fields/custom-function-params';

import { Subject, takeUntil, tap } from 'rxjs';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Injectable({
  providedIn: 'root'
})
export class HooksService implements OnDestroy {


  constructor(private fieldTypes: MCFieldTypesService) { }

  onDestroy$ = new Subject<void>();
  ngOnDestroy(): void {

    this.onDestroy$.next();

    this.onDestroy$.complete();

  }
  specificChangeEvents(customFunctionsParams: MICustomFunctionsParams) {
    const eventsCallBackService = customFunctionsParams.injector.get(customFunctionsParams.eventsCallBackService);

    customFunctionsParams.field?.formControl?.valueChanges.pipe(
      takeUntil(this.onDestroy$),
      tap(val => {
        customFunctionsParams.value = val;
        const changeEvents = customFunctionsParams.fieldSchema.events.filter(e => e.event == MC_EVENT_TYPE.OnChange);
        changeEvents.forEach(e => eventsCallBackService.eventsCallBack[e.functionName](customFunctionsParams));

      }),
    ).subscribe();
  };

  specificInitEvents(customFunctionsParams: MICustomFunctionsParams) {
    const onInitEvents = customFunctionsParams.fieldSchema.events.filter(e => e.event == MC_EVENT_TYPE.OnInit);
    const eventsCallBackService = customFunctionsParams.injector.get(customFunctionsParams.eventsCallBackService);

    onInitEvents.forEach(e => {
      if (eventsCallBackService.eventsCallBack[e.functionName]) {
        eventsCallBackService.eventsCallBack[e.functionName](customFunctionsParams)
      }
      else {
        console.error(`onInitEvents event fail field: ${customFunctionsParams.fieldSchema.name}, function ${e.functionName}`)
      }
    });

  };


  hooksInit(customFunctionsParams: MICustomFunctionsParams): (field: FormlyFieldConfig) => void {
    const eventsCallBackService = customFunctionsParams.injector.get(customFunctionsParams.eventsCallBackService);
    let hooksFN = (_field: FormlyFieldConfig) => {
    };
    try {
      if (customFunctionsParams.fieldSchema.events && customFunctionsParams.fieldSchema.events.length) {
        if (this.fieldTypes.isAutoComlete(customFunctionsParams.fieldSchema.type) || this.fieldTypes.isSelect(customFunctionsParams.fieldSchema.type)) {
          hooksFN = (_field: FormlyFieldConfig) => {
            this.specificInitEvents(customFunctionsParams);
            if (this.fieldTypes.isSelect(customFunctionsParams.fieldSchema.type)) {
              this.specificChangeEvents(customFunctionsParams);
            }
          }
        }
        else
          if (this.fieldTypes.isRadio(customFunctionsParams.fieldSchema.type)) {
            hooksFN = (field: FormlyFieldConfig) => {
              customFunctionsParams.field = field;
              this.specificInitEvents(customFunctionsParams);
            }
          }
          else {
            hooksFN = (field: FormlyFieldConfig) => {
              customFunctionsParams.field = field;
              const events = customFunctionsParams.fieldSchema.events.filter(e => e.event == MC_EVENT_TYPE.OnInit);
              events.forEach(e => eventsCallBackService.eventsCallBack[e.functionName](customFunctionsParams));
            }
          }

      }
    }
    catch (expression) {
      console.error(customFunctionsParams.fieldSchema.name, 'faild hooks Init : ', expression);
    }
    return hooksFN;

  }
}